import type { ShipmentRequest } from '../../types/marketplace';

const ACTIONABLE_MATCH_STATUSES = new Set(['matched', 'notified', 'opened']);

export function hasOperatorSuggestion(request: ShipmentRequest): boolean {
    const match = request.operator_match;

    if (!match || request.operator_has_quote) {
        return false;
    }

    return ACTIONABLE_MATCH_STATUSES.has(match.status);
}

export function isProximitySuggestion(request: ShipmentRequest): boolean {
    return hasOperatorSuggestion(request) && request.operator_match?.match_source !== 'return_intent';
}

export function countOperatorSuggestions(requests: ShipmentRequest[]): number {
    return requests.reduce((count, request) => count + (hasOperatorSuggestion(request) ? 1 : 0), 0);
}

export function sortRequestsBySuggestionPriority(requests: ShipmentRequest[]): ShipmentRequest[] {
    return [...requests].sort((left, right) => {
        const leftSuggested = hasOperatorSuggestion(left) ? 1 : 0;
        const rightSuggested = hasOperatorSuggestion(right) ? 1 : 0;

        if (leftSuggested !== rightSuggested) {
            return rightSuggested - leftSuggested;
        }

        const leftPostedAt = left.posted_at ?? left.created_at ?? '';
        const rightPostedAt = right.posted_at ?? right.created_at ?? '';

        if (leftPostedAt !== rightPostedAt) {
            return rightPostedAt.localeCompare(leftPostedAt);
        }

        return right.id - left.id;
    });
}

export function formatSuggestionDistance(value: number | null | undefined): string | null {
    if (typeof value !== 'number' || !Number.isFinite(value) || value < 0) {
        return null;
    }

    if (value < 10) {
        return `${value.toFixed(1)} km`;
    }

    return `${Math.round(value)} km`;
}
